import { create } from 'zustand';

// Global document search, shared between the top app-bar search field and the
// Documents (Dashboard) list. Typing in the app bar filters the list; on other
// pages, submitting navigates to /dashboard where the query is already applied.
interface SearchState {
  query: string;
  setQuery: (q: string) => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  query: '',
  setQuery: (query) => set({ query }),
}));
